export const trackAnalyticsEvent = (
  eventName: string,
  payload: any = null
): Promise<never> =>
  new Promise((resolve, reject) => {
    const analyticsReady = Boolean(window.analytics);
    if (analyticsReady) {
      window.analytics.track(eventName, payload, resolve);
    } else {
      reject();
    }
  });

export default trackAnalyticsEvent;
